export const WATCHLIST_UPDATE_LOG_MESSAGES = {
  NOT_FOUND: 'No watchlist update logs were found',
};


// WEBPACK FOOTER //
// ./src/features/reports/constants/watchlistUpdateLogMessages.js